module.exports = __webpack_public_path__ + "img/logo_corner.7d626741.png";